import {
  getQuantityIndicators,
  getPercentageIndicators
} from '@/common/services/modules/general-indicators'

const initialValueState = {
  isDisplayAbsolute: false,
  visibleIsLoading: false,
  isIndicatorsVisible: true,
  loadingError: false,
  info: {
    approved: 0,
    notApproved: 0,
    disapproved: 0,
    canceled: 0,
    suspended: 0,
    fraud: 0,
    others: 0,
    chargeBack: 0,
    sla200Min: 0,
    sla24Hr: 0,
    slaIsolated48Hr: 0,
    slaTotalized48Hr: 0,
    totalSla: 0
  }
}

export default {
  namespaced: true,
  state: initialValueState,
  mutations: {
    UPDATE_QUANTITY(state, payload) {
      state.info = payload
      state.isDisplayAbsolute = true
    },
    UPDATE_PERCENTAGE(state, payload) {
      state.info = payload
      state.isDisplayAbsolute = false
    },
    HANDLE_REQUEST_LOADING(state, visible) {
      state.visibleIsLoading = visible
    },
    TOGLE_VISIBLE_INDICATORS(state, payload) {
      state.isIndicatorsVisible = payload
    },
    TOGGLE_ERROR(state, payload) {
      state.loadingError = payload
    },
    RESET_STATE(state) {
      state.info = initialValueState.info
    }
  },
  actions: {
    async getQuantity({ state, commit }, params) {
      const { id, period } = params
      try {
        const { data, status } = await getQuantityIndicators(id, period)
        if (status === 200) {
          await commit('TOGGLE_ERROR', false)
          commit('UPDATE_QUANTITY', data)
        } else if (status === 204) {
          await commit('RESET_STATE')
          commit('TOGLE_VISIBLE_INDICATORS', false)
        } else {
          throw new Error('Invalid Return')
        }
      } catch (err) {
        await commit('RESET_STATE')
        if (err.response?.status === 401 || err.response?.status === 403) {
          commit('TOGLE_VISIBLE_INDICATORS', false)
        } else {
          commit('TOGGLE_ERROR', true)
        }
      } finally {
        commit('HANDLE_REQUEST_LOADING', false)
      }
    },
    async getPercentage({ state, commit }, params) {
      const { id, period } = params
      try {
        const { data, status } = await getPercentageIndicators(id, period)
        if (status === 200) {
          await commit('TOGGLE_ERROR', false)
          commit('UPDATE_QUANTITY', data)
        } else if (status === 204) {
          await commit('RESET_STATE')
          commit('TOGLE_VISIBLE_INDICATORS', false)
        } else {
          throw new Error('Invalid Return')
        }
      } catch (err) {
        await commit('RESET_STATE')
        if (err.response?.status === 401 || err.response?.status === 403) {
          commit('TOGLE_VISIBLE_INDICATORS', false)
        } else {
          commit('TOGGLE_ERROR', true)
        }
      } finally {
        commit('HANDLE_REQUEST_LOADING', false)
      }
    }
  },
  getters: {
    indicatorsValue(state) {
      const clonedOrders = structuredClone(state.info)

      if (!state.isDisplayAbsolute) {
        Object.keys(clonedOrders).forEach(
          key => (clonedOrders[key] = `${clonedOrders[key].toFixed(2)}%`)
        )
      } else {
        Object.keys(clonedOrders).forEach(
          key => (clonedOrders[key] = `${clonedOrders[key].toFixed(2)}%`)
        )
      }

      return clonedOrders
    },
    visibleIndicators(state) {
      return state.isIndicatorsVisible
    }
  }
}
